import React from 'react'

import accountantDarkIcon from '@/components/misc/CompanyIcon/icons/accountant--dark.svg'
import accountantLightIcon from '@/components/misc/CompanyIcon/icons/accountant--light.svg'
import corporateFinanceDarkIcon from '@/components/misc/CompanyIcon/icons/corporate_finance--dark.svg'
import corporateFinanceLightIcon from '@/components/misc/CompanyIcon/icons/corporate_finance--light.svg'
import defaultIconDark from '@/components/misc/CompanyIcon/icons/default--dark.svg'
import defaultIconLight from '@/components/misc/CompanyIcon/icons/default--light.svg'
import estatePlannerDarkIcon from '@/components/misc/CompanyIcon/icons/estate_planner--dark.svg'
import estatePlannerLightIcon from '@/components/misc/CompanyIcon/icons/estate_planner--light.svg'
import ifaDarkIcon from '@/components/misc/CompanyIcon/icons/ifa--dark.svg'
import ifaLightIcon from '@/components/misc/CompanyIcon/icons/ifa--light.svg'
import insuranceAdviserDarkIcon from '@/components/misc/CompanyIcon/icons/insurance_adviser--dark.svg'
import insuranceAdviserLightIcon from '@/components/misc/CompanyIcon/icons/insurance_adviser--light.svg'
import investmentManagementDarkIcon from '@/components/misc/CompanyIcon/icons/investment_management--dark.svg'
import investmentManagementLightIcon from '@/components/misc/CompanyIcon/icons/investment_management--light.svg'
import mortgageAdviserDarkIcon from '@/components/misc/CompanyIcon/icons/mortgage_adviser--dark.svg'
import mortgageAdviserLightIcon from '@/components/misc/CompanyIcon/icons/mortgage_adviser--light.svg'
import solicitorDarkIcon from '@/components/misc/CompanyIcon/icons/solicitor--dark.svg'
import solicitorLightIcon from '@/components/misc/CompanyIcon/icons/solicitor--light.svg'
import SvgImage, { SvgImageProps } from '@/components/misc/SvgImage'
import { COMPANY_TYPE_CODE } from '@/lib/constants'
import { CompanyTypeCode } from '@/types/misc'

type Props = SvgImageProps & {
  companyTypeCode: CompanyTypeCode
  mode?: 'light' | 'dark'
}

const CompanyTypeIcon: React.FC<Props> = ({
  companyTypeCode,
  mode = 'light',
  ...props
}) => {
  const icons: { [Key in CompanyTypeCode]?: [string, string] } = {
    [COMPANY_TYPE_CODE.accountant]: [accountantLightIcon, accountantDarkIcon],
    [COMPANY_TYPE_CODE.corporate_finance]: [
      corporateFinanceLightIcon,
      corporateFinanceDarkIcon,
    ],
    [COMPANY_TYPE_CODE.corporate_finance_non_fca]: [
      corporateFinanceLightIcon,
      corporateFinanceDarkIcon,
    ],
    [COMPANY_TYPE_CODE.estate_planner]: [
      estatePlannerLightIcon,
      estatePlannerDarkIcon,
    ],
    [COMPANY_TYPE_CODE.ifa]: [ifaLightIcon, ifaDarkIcon],
    [COMPANY_TYPE_CODE.insurance_adviser]: [
      insuranceAdviserLightIcon,
      insuranceAdviserDarkIcon,
    ],
    [COMPANY_TYPE_CODE.investment_management]: [
      investmentManagementLightIcon,
      investmentManagementDarkIcon,
    ],
    [COMPANY_TYPE_CODE.mortgage_adviser]: [
      mortgageAdviserLightIcon,
      mortgageAdviserDarkIcon,
    ],
    [COMPANY_TYPE_CODE.business_lending_non_fca]: [
      mortgageAdviserLightIcon,
      mortgageAdviserDarkIcon,
    ],
    [COMPANY_TYPE_CODE.solicitor]: [solicitorLightIcon, solicitorDarkIcon],
  }

  const icon = icons[companyTypeCode] ?? [defaultIconLight, defaultIconDark]

  return <SvgImage {...props} src={mode === 'light' ? icon[0] : icon[1]} />
}

export default CompanyTypeIcon
